<template>
  <div>
    <nav class="navbar navbar-expand-lg menu">
      <!-- <router-link to="/">Logo</router-link> faCalendarAlt, faWrench-->
      <ul class="nav">
        <!-- <li v-on:click="test()">
          Test
        </li> -->
        <li class="nav-item" v-if="mobile">
          <router-link to="/">{{$t("home")}}</router-link>
        </li>
        <li class="nav-item" v-if="mobile">
          <Popup>
            <template v-slot:trigger><font-awesome-icon icon="calendar-alt" />{{ $t("wallets") }}</template>
            <template v-slot:content><Period></Period></template>
          </Popup>
        </li>
        <li class="nav-item" v-if="!mobile">
          <router-link to="/wallets"
            ><font-awesome-icon icon="calendar-alt" />{{ $t("wallets") }}</router-link
          >
        </li>
        <li class="nav-item">
            <router-link to="/wishlist"><font-awesome-icon icon="comment-dollar" />{{ $t("wishlist") }}</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/setting"
            ><font-awesome-icon icon="wrench" />{{ $t("setting") }}</router-link
          >
        </li>
      </ul>
    </nav>

    <div class="logo" v-if="!mobile">
      <router-link to="/">
        <img alt="Vue logo" src="./../assets/piggybank.svg" />
      </router-link>
    </div>
  </div>
</template>

<script>
import Period from './Period.vue';
import MoneyCheckbox from './MoneyCheckbox';
export default {
  components: { Period },
  data() {
    return {
      mobile: false,
    };
  },
  mounted() {
    this.mobile = this.$piggyBank.mobile;
    this.$root.$on("mobile", (mobile) => (this.mobile = mobile));
  },
  // methods: {
  //   test() {
  //     console.log(this.$dynamic);

  //     this.$dynamic.showElement(MoneyCheckbox);
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.menu {
  li {
    margin: 0px 5px;
  }
}

.logo {
  display: flex;
  justify-content: center;

  & > * {
    width: 60%;
    display: block;
    background: white;
    border-radius: 50%;
    padding: 50px;
  }
}
</style>